import React, { useContext, useState } from "react";
import "./DashHeader.scss";
import { Link, useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { UserContext } from "../../Context";
import { FaUser } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import logo from "../../assets/header/logos/matte_logo.png";
import { Tooltip } from 'react-tooltip'
import { FaBell } from "react-icons/fa";
import { IoBook } from "react-icons/io5";
import Bio_Popup from "../bio_popup/Bio_Popup";
const DashHeader = () => {
  const { user, logout, notificationData } = useContext(UserContext);
  const [bio_pop, setBio_pop] = useState(false)
  const navigate = useNavigate();

  const logoutApi = () => {
    logout().then((data) => {
      if (data.success) {
        localStorage.removeItem("auth");
        navigate("/", { replace: true });
      }else{
        console.log(data.message)
      }
    })
  }
  return (
    <>
      {bio_pop && <Bio_Popup setBio_pop={setBio_pop} />}
      <div className="header_parent">
        <div className="left">

          <img src={logo} alt="" />
          <span>A bridge from local to global </span>
        </div>
        <div className="right">
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/add-products">Add Products</Link>
          <Link to="/orders">Orders</Link>
          <div className="dropdown">
            <div className="label">
              <span>
                <FaRegUser />
              </span>
              {user?.name}
            </div>
            <div className="options">
              <Link to="/seller-profile" className="nav" >
                <span>
                  <FaUser />
                </span>
                My Profile</Link>
              <Link onClick={()=>setBio_pop(true)} className="nav" >
                <span>
                  <IoBook />
                </span>
                About Me </Link>
              <div className="logout nav" onClick={logoutApi}>
                <span>
                  <IoMdLogOut />
                </span>
                logout
              </div>
            </div>
          </div>

          <Link to="/notification" class="notification" data-tooltip-id="my-tooltip" data-tooltip-content="Notification" >
            <FaBell />

            <span className="counter" >
              {notificationData?.length}
            </span>
            <Tooltip id="my-tooltip" />
          </Link>
        </div>
      </div>
    </>
  );
};

export default DashHeader;
